import {Component, Input, OnInit, SimpleChanges} from '@angular/core';

@Component({
	selector: 'trend',
	template: `
		<small [class]="val >= 0 ? 'text-success' : 'text-danger'">{{formatValue}}</small>
	`
})
export class TrendComponent implements OnInit {
	@Input() public val: number;
	formatValue = '';

	constructor() {
		
	}

	ngOnInit() {

	}
	
	ngOnChanges(changes: SimpleChanges) {
		if(changes.val && changes.val.currentValue) {
			let n = changes.val.currentValue;
			
			if(!isNaN(n) && isFinite(n)) {
				this.formatValue = (n >= 0 ? '↑' : '↓') + ' ' + Math.abs(n);	
			} else {
				this.formatValue = '';
			}			
		}
	}
}
